module.exports = __webpack_public_path__ + "static/media/bleeding3.565bc387.png";